import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getAllNotificationsStart, markAsReadStart } from '../../../store/redux-slices/fetchData';
import { io } from 'socket.io-client';
import { Col, Row } from 'react-bootstrap';
import Popup from './popup';
import NotificationIcon from '../../../components/NotificationIcon';

const Header = () => {
  /*   const [alertpopoverOpen, setAlertPopoverOpen] = useState(false);
    const dispatch = useDispatch()
    const markAsRead = () => {
      dispatch(markAsReadStart({ markAllAsRead: true }))
    }
    const [notificationImage, setNotificationImage] = useState(inactiveNotificationIcon)
  
    const { notificationData } = useSelector((state) => state.fetch);
  
    const onNotificationClose = () => {
      setAlertPopoverOpen(false)
      setNotificationImage(inactiveNotificationIcon)
      markAsRead()
    }
    const fetchNotifications = () => {
      dispatch(getAllNotificationsStart());
    };
  
    const onNotificationOpen = () => {
      setAlertPopoverOpen(!alertpopoverOpen)
      fetchNotifications()
    }
    const socket = io('https://admin-api.owners.bet/public', {
      path: '/api/socket',
      transports: ['websocket'],
      withCredentials: false,
      autoConnect: true,
    });
  
    const checkAllMessageReaded = () => {
      if (notificationData?.length > 0) {
        const isNotReaded = notificationData.some(notification => notification.isRead === false)
        isNotReaded ? setNotificationImage(activeNotificationIcon) : setNotificationImage(inactiveNotificationIcon)
      }
    }
  
    // Preload both notification images when component mounts
    useEffect(() => {
      const preloadImages = () => {
        const img1 = new Image();
        img1.src = activeNotificationIcon;
  
        const img2 = new Image();
        img2.src = inactiveNotificationIcon;
      };
  
      preloadImages();
    }, []);
  
    useEffect(() => {
      checkAllMessageReaded()
    }, [notificationData])
  
    useEffect(() => {
      const handleNewUserSignup = (data) => {
        setNotificationImage(activeNotificationIcon)
      };
      socket.on('admin:new-user-signup', handleNewUserSignup);
  
      return () => {
        socket.off('admin:new-user-signup', handleNewUserSignup);
        socket.disconnect();
      };
    }, []); */


  return (
    <div className='section-header-wrap mt-n3 mx-n3'>
      <Row>
        <Row className="align-items-center">
          <Col lg={6} xs={6}>
            <h2 className="title-text">Dashboard</h2>
          </Col>

          <Col lg={6} xs={6} className="text-end">
            <NotificationIcon />
          </Col>

        </Row>

        {/* <Col xs='auto' className='d-flex align-items-center'>
                      <div className='d-flex justify-content-end align-items-center'>
                        <ClientFilter
                          setSelectedClient={setSelectedClient}
                          setSelectedPortal={setSelectedPortal}
                          selectedClient={selectedClient}
                        />

                        {selectedClient && (
                          <PortalFilter
                            setSelectedPortal={setSelectedPortal}
                            selectedPortal={selectedPortal}
                            selectedClient={selectedClient}
                          />
                        )}
                      </div>
                      <small>
                        <Button
                          size='sm'
                          className='circle-button'
                          variant={elasticHealth ? 'success' : 'danger'}
                        />&nbsp;Elastic &nbsp;
                      </small>
                    </Col> */}
      </Row>
    </div>
  )
}

export default Header